import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLastRoute } from '../hooks/useNavigationMemory';

/**
 * Entrando dalla radice (link generico, PWA, segnalibro) si riparte dall'ultima
 * pagina visitata invece che sempre dalla dashboard. Se non c'è nulla di
 * memorizzato — o la rotta salvata non è più valida — si torna alla dashboard.
 */
const LastRouteRedirect: React.FC = () => {
  // Calcolata una sola volta al mount: il valore cambia mentre si naviga e non
  // deve far ripartire il redirect.
  const [target] = React.useState(() => getLastRoute() || '/dashboard');
  return <Navigate to={target} replace />;
};

export default LastRouteRedirect;
